import Model from "./abstract/Model";

export default class Image extends Model {

  constructor(props) {
    super();

    this.initializeAttributes(props, {});
  }

  // No url getter: `url` and `thumb_url` arrive on the payload as expiring URLs
  // from MediaUrl. Building `API_URL + '/images/' + id` here instead does not
  // work for <img src>, because a browser issued request carries no
  // Authorization header and that route sits behind auth:api.
}
